/**
 * HorseLink component
 * Links to horse profile product
 * using horse Id and Horse name
 */
import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import horseUrlBuilder from '../utils/horseUrlBuilder';
/**
 * Stateless component.
 * Url can be built only using horseId and horseName,
 * so in case one of them does not have truthy value - return dash.
 * @param horseId
 * @param horseName
 * @constructor
 */
const HorseLink = ({ horseId, horseName }) => (
    horseId && horseName ? (
        <a
            href={horseUrlBuilder(horseId, horseName)}
            className="js-popupLink ui-link ui-link_table"
        >
            { horseName }
            <Svg
                iconName="right"
                size="XSmall"
                className="ui-icon ui-icon__btn"
            />
        </a>
    ) : <span>—</span>
);
/**
 * Prop types validation
 * @type {{horseId: *, horseName: *}}
 */
HorseLink.propTypes = {
    horseId: PropTypes.number,
    horseName: PropTypes.string
};

export default HorseLink;



// WEBPACK FOOTER //
// ./src/js/common/HorseLink.js